@if(availableCultures().length > 1) {
  <select class="form-control" [ngModel]="selectedLanguage()" (change)="changeLocale($event)" [disabled]="isLoading()">
    @if(isLoading()) {
      <option disabled selected>Loading...</option>
    } @else {
      @for (languageOption of availableCultures(); track languageOption.language) {
        <option [value]="languageOption.language">
          {{ languageOption.name }}
        </option>
      }
    }
  </select>
}
